// Route watchers may observe a destination already selected by the user.
export function replaceIfChanged(router, target) {
  if (router.resolve(target).route.fullPath === router.currentRoute.fullPath) return Promise.resolve();
  return router.replace(target).catch(error => {
    if (error && ['NavigationDuplicated', 'NavigationCancelled', 'NavigationRedirected'].includes(error.name)) return;
    throw error;
  });
}
